import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Quote from './pages/Quote';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import StayInTouch from './pages/StayInTouch';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="stay-in-touch" element={<StayInTouch />} />
          <Route path="quote" element={<Quote />} />
          <Route path="terms" element={<Terms />} />
          <Route path="privacy" element={<Privacy />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;